import { useAuth } from 'context'
import { Navigate, useLocation } from 'react-router-dom'

export default function Blank() {
  const { status } = useAuth()
  const location = useLocation()

  if (status === 'unauthorized') {
    return <Navigate to={'/account/sign-in'} state={{ from: location }} />
  }

  return <></>
}
